import { memo } from "react"
import { Heart, X } from "react-feather"
import { motion, useTransform } from "framer-motion"

const CardEffect = memo(({ animations, x, positive, xInput }) => {
    return (
        <motion.div
            style={{
                x: useTransform(x, xInput, animations.x, { clamp: true }),
                y: useTransform(x, xInput, animations.y, { clamp: true }),
                rotate: useTransform(x, [-300, 300], animations.rotate, {
                    clamp: true,
                }),
                scale: useTransform(x, xInput, animations.scale, {
                    clamp: true,
                }),
                opacity: useTransform(x, [-150, 0, 150], animations.opacity, {
                    clamp: true,
                }),
            }}
            className={"absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 z-10"}
        >
            {positive ? (
                <Heart className={"fill-pink-300 text-pink-200 size-12"} />
            ) : (
                <X className={"size-12 text-red-500"} />
            )}
        </motion.div>
    )
})

export default CardEffect
